import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledVisitContinuouslyUsedMedicineTableRow = styled(StyledFlex)`
   width: 100%;
   padding: 2px 0;
`;
